export class QueryListResultModel<T> {
    constructor(public items: Array<T>, public totalRows: number,public canUserCreateAssessment: boolean) {
    this.items = items;
      this.totalRows = totalRows;
      this.canUserCreateAssessment = canUserCreateAssessment;
  }

  static init = () => new QueryListResultModel([], 0,false);
}
